import { render, staticRenderFns } from "./PopupBubble.vue?vue&type=template&id=13d93be2"
import script from "./PopupBubble.vue?vue&type=script&lang=js"
export * from "./PopupBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports